module.exports = __webpack_public_path__ + "static/media/rni-logo-sm.c30c0b67.png";